import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import 'react-app-polyfill/ie9';
import { createRoot } from 'react-dom/client';
import App from './app/app';

import ReactGA from "react-ga4";
import { clarity } from 'react-microsoft-clarity';
import './analytics/posthog';
import 'react-tooltip/dist/react-tooltip.css';
import "./index.scss";

Sentry.init({
  dsn: 'https://dc2907ad11db4193b7dcdf9c8a00f1c8@o127109.ingest.sentry.io/4504360251883520',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  beforeSend(event, hint) {
    const error = hint?.originalException;
    // Drop Firebase unsupported-browser noise
    if (error && error?.code === 'messaging/unsupported-browser') {
      return null;
    }
    return event;
  },
});

const isWhiteLabelledDomain =
  !window.location.href.includes('salesblink') &&
  !window.location.href.includes('localhost');

if (!isWhiteLabelledDomain) {
  ReactGA.initialize("G-9BFL10G91W");
  clarity.init('co5im8sdm8'); // Microsoft Clarity Tracking
}

const container = document.getElementById('root');
const root = createRoot(container);
// root.render(
//   <Sentry.ErrorBoundary showDialog>
//     <App />
//   </Sentry.ErrorBoundary>
// );
root.render(<App />);

const welcome = () => console.log('Welcome to SalesBlink 🚀');

welcome('de529c70-eb80-4dfb-9540-5075db7545bf');